import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutButton from "./LogoutButton";
import Navbar from "./Navbar";
import { useState } from "react";
import { getMenusFromToken } from "../utils/auth";
import { useTheme } from "@mui/material/styles";

const drawerWidth = 220;

export default function Layout({ title, children }) {
  const menus = getMenusFromToken();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const drawerContent = (
    <Box sx={{ bgcolor: "#1976d2", color: "white", height: "100%" }}>
      <Navbar menus={menus} />
    </Box>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* 🔹 Header / AppBar */}
      <AppBar
        position="fixed"
        sx={{
          bgcolor: "#125ea5",
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
            px: { xs: 1.5, sm: 2 },
          }}
        >
          {/* Mobile menu button */}
          {isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            noWrap
            sx={{
              flex: 1,
              minWidth: 0,
              fontSize: { xs: 16, sm: 18, md: 20 },
            }}
          >
            {title}
          </Typography>
          <LogoutButton />
        </Toolbar>
      </AppBar>

      {/* 🔹 Permanent Drawer (Desktop) */}
      {!isMobile && (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              bgcolor: "#1976d2",
              color: "white",
              pt: { xs: "56px", sm: "64px" }, // 👈 shift below AppBar height
            },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {/* 🔹 Temporary Drawer (Mobile) */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              bgcolor: "#1976d2",
              color: "white",
              pt: { xs: "56px", sm: "64px" }, // 👈 same offset for mobile
            },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {/* 🔹 Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#f5f5f5",
          width: "100%",
          minWidth: 0,
          p: { xs: 1.5, sm: 2, md: 3 },
          pt: { xs: 9, sm: 10, md: 12 },
          ml: { md: `${drawerWidth}px` },
          display: "flex",
          flexDirection: "column",
          alignItems: "center", // centers children horizontally
          justifyContent: "flex-start",
          minHeight: "calc(100vh - 100px)",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "1200px", minWidth: 0 }}>
          {children}
        </Box>
      </Box>

      {/* 🔹 Footer */}
      <Box
        sx={{
          bgcolor: "#1976d2",
          color: "white",
          textAlign: "center",
          p: { xs: 1.5, md: 2 },
          fontSize: { xs: "0.8rem", md: "1rem" },
          mt: "auto",
        }}
      >
        © {new Date().getFullYear()} Petrol Pump Management System
        <br />
        Powered by <b>Bytesy Solutions Ltd</b>
      </Box>
    </Box>
  );
}
